export default __webpack_public_path__ + "static/media/timer.1fd761f8.svg";